import React from 'react';

const Card = props => {
    return (
        <div className="qf-info-card">

            <div className="d-flex flex-row h-100 align-items-center">
                <div className="mx-3 w-auto">
                    <div className="qf-card-icon d-flex align-items-center">
                        {props.svg}
                    </div>
                </div>
                <div className="w-auto">
                    <h3 className="title">{props.title}</h3>
                    <span className="description">{props.description}</span>
                </div>
            </div>

        </div>
    );
};

export default Card;



// WEBPACK FOOTER //
// ./src/customModules/Home/components/Card.js